/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdStudentData200,
  GetApiV1PersonIdStudentData401,
  GetApiV1PersonIdStudentData404,
  GetApiV1PersonIdStudentData500,
  GetApiV1PersonIdStudentDataPathParams,
  GetApiV1PersonIdStudentDataQueryResponse,
} from "../../types/personStudentController/GetApiV1PersonIdStudentData.ts";
import { personStudentDataViewModelSchema } from "../personStudentDataViewModelSchema.ts";

export const getApiV1PersonIdStudentDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdStudentDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdStudentData200Schema = z.lazy(
  () => personStudentDataViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdStudentData200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdStudentData401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdStudentData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdStudentData404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdStudentData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdStudentData500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdStudentData500>;

export const getApiV1PersonIdStudentDataQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdStudentData200Schema,
) as unknown as ToZod<GetApiV1PersonIdStudentDataQueryResponse>;
